import { isMailboxInfo, type MailboxInfo } from "owa-client-types";
import type { AccountSourceType } from "owa-account-source-list-types";
import { callFallbackMailboxFunction } from "./fallbackMailboxFunction";
import { callFallbackIdentityInfoFunction } from "./fallbackIdentityInfoFunction";
import { getAnchorMailboxMailboxInfo } from "owa-anchormailbox";
import { getIdentityKeyForIdentityInfo, getIdentityInfoForMailboxInfo, type IdentityInfo, } from "owa-auth-types";

export function getMailboxInfoOrDefault(mailboxInfo?: MailboxInfo): MailboxInfo {
    return mailboxInfo ?? callFallbackMailboxFunction();
}

export function getIdentityInfoOrDefaultFromMailboxInfo(mailboxInfo?: MailboxInfo, callerTypeHint?: AccountSourceType): IdentityInfo {
    let identityInfo = undefined;
    if (mailboxInfo) {
        if (callerTypeHint) {
            // use the hint provided by the caller to buld the identity info
            return {
                providerType: callerTypeHint,
                userPrincipalName: mailboxInfo.userIdentity,
            };
        }
        
        identityInfo = getIdentityInfoForMailboxInfo(getMailboxInfoOrDefault(mailboxInfo));
    }
    
    return identityInfo ?? callFallbackIdentityInfoFunction(mailboxInfo);
}

/**
 * Returns the unique id associated with either the mailboxInfo or userMailboxInfo
 * @param identitySource Specifies the MailboxInfo or IdentityInfo for which a key is to be obtained
 */
export function getIdentityInfoKeyForRequest(identitySource: MailboxInfo | IdentityInfo, callerTypeHint?: AccountSourceType): string {
    const identityInfo = isMailboxInfo(identitySource)
        ? getIdentityInfoOrDefaultFromMailboxInfo(identitySource, callerTypeHint)
        : identitySource;
    return getIdentityKeyForIdentityInfo(identityInfo);
}

/**
 * Returns the anchor mailbox that should be used with the request
 * @param sourceId Specifies the sourceId of the account for which we are communicating with
 * @returns return the mailbox user identity
 */
export async function getAnchorMailbox(mailboxInfo?: MailboxInfo): Promise<string> {
    const mailboxInfoObject = getMailboxInfoOrDefault(mailboxInfo);
    return getAnchorMailboxMailboxInfo(mailboxInfoObject);
}
